/* eslint-disable no-return-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import axios from 'axios';
import {
  handleCookies,
  showNotification,
  getClientDeviceToken,
} from '@/static/helpers';

import ResourceManager from '@/services/resource.service';
import AccountService from '@/services/account';
// _________________________________________________________ Service root path definitions _//

const kariyerUrl = process.env.VUE_APP_KARIYER_URL;
const siriusUrl = process.env.VUE_APP_SIRIUS_URL;

// _______________________________________________________________Defaults _//

axios.defaults.baseURL = `${process.env.VUE_APP_HRVENUEGLB_API}/base`;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// _______________________________________________________________Response interceptor _//

axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    if (error.response) {
      // eslint-disable-next-line no-use-before-define
      ErrorHandling(error.response);

      // check if unauthorized error returned
      if (error.response.status === 401 || error.response.status === 403) {
        // redirect to login page
        AccountService.deleteToken();
        AccountService.resetOtp();
        AccountService.reset2fa();
        AccountService.resetOptionalOtp();
        localStorage.removeItem('lastOtpPath');

        setTimeout(() => {
          window.location.reload();
        }, 100);
      }

      // request is rejected and will direct logic to the catch() method
      return Promise.reject(error);
    }
    // request is rejected and will direct logic to the catch() method
    return Promise.reject(error);
  },
);

// ___________________________________________________________________ Request interceptor _//

const onlyEnglishPages = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
];

axios.interceptors.request.use(
  (config) => {
    const atsversion = localStorage.getItem('atsversion');
    if (atsversion) config.headers.common.AtsVersion = atsversion;
    // remove token
    delete config.headers.Authorization;
    // set
    config.headers['Accept-Language'] = onlyEnglishPages.includes(window.location.pathname)
      ? 'en-US'
      : ResourceManager?.CurrentLang ?? 'en-US';
    config.headers['Current-Language'] = onlyEnglishPages.includes(window.location.pathname) ? 'en-US' : ResourceManager?.CurrentLang ?? 'en-US';
    // get token cookie
    const token = handleCookies.getCookie('hrvenue_identity');
    // if token exists, set headers
    if (token && !config.withoutAuth) {
      const managementCredentialToken = handleCookies.getCookieWithNativeJs(
        'ManagementCredentialToken',
      );
      config.headers.Authorization = `Bearer ${token}`;
      if (managementCredentialToken) {
        config.headers.ManagementCredentialToken = managementCredentialToken;
      }
    }
    config.headers.clientDeviceToken = getClientDeviceToken();
    return config;
  },
  (error) => Promise.reject(error),
);

// _______________________________________________________________________Service Paths _//
export const serviceConfigs = {
  resource: {
    root: 'Resource',
    getListByLanguage: {
      type: 'get',
      path: 'list',
    },
    changeLanguage: {
      type: 'get',
      path: 'changeLanguage',
    },
  },
  account: {
    root: 'Auth',
    logOut: {
      type: 'get',
      path: 'logout',
    },
    changeUserPassword: {
      type: 'post',
      path: 'change-password',
    },
    login: {
      type: 'post',
      path: '',
    },
    forgotPassword: {
      type: 'post',
      path: 'forgot-password',
    },
  },
  faq: {
    root: 'faq',
    getFaqList: {
      path: 'getFaqList',
      type: 'get',
    },
    getFaq: {
      path: 'getFaq',
      type: 'get',
    },
  },
};

// __________________________________________________________Axios Instances _//

export const serviceWrapper = (
  serviceGroupObj,
  servicePathObj,
  params,
  config = {},
) => {
  // set service path
  let path = `${process.env.VUE_APP_HRVENUEGLB_API}/base/${serviceGroupObj.root}${servicePathObj.path ? `/${servicePathObj.path}` : ''}`;

  // set querystring params if type is GET
  if (params && servicePathObj.type === 'get') {
    let paramsIndex = 0;
    for (const prop in params) {
      // eslint-disable-next-line no-prototype-builtins
      if (params.hasOwnProperty(prop)) {
        paramsIndex === 0
          ? (path += `?${prop}=${params[prop]}`)
          : (path += `&${prop}=${params[prop]}`);
      }
      paramsIndex += 1;
    }
    params = { ...config };
  }

  if (params && servicePathObj.type === 'delete') {
    return axios.delete(path, { data: params, ...config })
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  }

  return axios[servicePathObj.type](path, params, config)
    .then((response) => {
      const latestVersion = localStorage.getItem('atsversion');
      const currentVersion = response.headers.atsversion;

      if (latestVersion === currentVersion) return response;
      if (currentVersion && currentVersion > latestVersion) {
        localStorage.setItem('atsversion', currentVersion);
        window.location.reload();
      }

      return response;
    })
    .catch((error) => Promise.reject(error));
};

const ErrorHandling = (response) => {
  const { body } = response.data;
  if (body) {
    let errorMessage = '';
    if (body.type === 'ValidationExceptionProblemDetails') {
      for (let i = 0; i < body.errorDetails.length; i += 1) {
        errorMessage += `<span><small>${body.errorDetails[i].message}</small></span></br>`;
      }
    } else {
      errorMessage = ` <p><small>${body.message}</small></p>`;
    }
    showNotification('Uyarı', errorMessage, 'error');

    return errorMessage;
  }
};

export default {
  serviceConfigs,
  serviceWrapper,
  kariyerUrl,
  siriusUrl,
};
